import { Paper, TableBody, TableHeader, TableRow, TableRowColumn, Table as TableUI } from "material-ui";
import PropTypes from "prop-types";
import React from "react";

export const Table = ({ className = "", head = [], rows = [], firstRowIsKey, ...props }) => {
  const shouldHideFirst = index => firstRowIsKey && index === 0;

  return (
    <Paper>
      <TableUI>
        <TableHeader displaySelectAll={false} enableSelectAll={false} adjustForCheckbox={false}>
          <TableRow>
            {head.map(headCell => (
              <TableRowColumn component="th" scope="row" style={{ color: "#9E9E9E", padding: 5 }}>
                {headCell}
              </TableRowColumn>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody displayRowCheckbox={false}>
          {rows.map(row => (
            <TableRow key={firstRowIsKey ? row[0] : row}>
              {row.map(
                (cell, i) =>
                  shouldHideFirst(i) ? null : (
                    <TableRowColumn component="th" scope="row" style={{ padding: 5 }}>
                      {cell}
                    </TableRowColumn>
                  )
              )}
            </TableRow>
          ))}
        </TableBody>
      </TableUI>
    </Paper>
  );
};

Table.propTypes = {
  absolute: PropTypes.bool,
  singleColor: PropTypes.bool,
  small: PropTypes.bool,
  firstRowIsKey: PropTypes.bool
};

export default Table;



// WEBPACK FOOTER //
// ./src/app/components/UI/Table/Table.js